import AddressLineOne from './AddressLineOne';


class AddressLineTwo extends AddressLineOne {
    static defaultProps = {
        'field': 'addressLine2',
        'id': 'addressline2'
    };

}


export default AddressLineTwo;
